<template>
  <div class="container" v-if="bibleData.length">
    <home-title
      title="学习宝典"
      link="https://lib.yiihuu.com/list/bible.php"
      :icon="require('@/assets/images/home/home_title/icon3.svg')"
    ></home-title>
    <div class="bible_box">
      <div class="me-list">
        <swiper ref="teamSwiper" :options="teamOptions">
          <swiper-slide v-for="e in bibleData" :key="e.album_id">
            <div class="banner_box ta3">
              <a
                :href="`https://lib.yiihuu.com/video/album.php?aid=${e.album_id}`"
                class="banner_link"
              >
                <div class="bible_img_box">
                  <img
                    class="bible_img"
                    :src="$homeSrc(e.album_smpicpath)"
                    alt=""
                  />
                  <div class="bible_time">
                    <i class="el-icon-time"></i> {{ e.album_total_playtime }}
                  </div>
                  <img
                    class="bottom_shadow"
                    src="@/assets/images/home/img_shadow.png"
                    alt=""
                  />
                </div>

                <div class="bible_title ta3 toh2">{{ e.album_name }}</div>
                <div class="bible_info">
                  <div class="left dfAic toh">
                    <img :src="e.avatar" alt="" /><span class="toh"
                      >讲师：{{ e.member_name }}</span
                    >
                  </div>
                  <div class="right dfAic toh">
                    <img src="@/assets/images/home/item_icon2.svg" alt="" />
                    <span class="toh">{{ e.play_count }}人在学</span>
                  </div>
                </div>
              </a>
            </div>
          </swiper-slide>
        </swiper>
        <div class="swiper-button-prev arrows"></div>
        <div class="swiper-button-next arrows"></div>
      </div>
    </div>
  </div>
</template>

<script>
import homeTitle from "./components/homeTitle";
export default {
  name: "studyBible",
  components: { homeTitle },
  props: {
    bibleData: {
      type: Array,
      default: [],
    },
  },
  data() {
    return {
      teamOptions: {
        slidesPerView: "auto",
        spaceBetween: 0,
        loop: true,
        loopedSlides: 6,
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
      },
    };
  },
  mounted() {},
  methods: {},
};
</script>

<style lang="scss" scoped>
.container {
  padding-top: 50px;
  .bible_box {
    width: 100%;
    .me-list {
      position: relative;
      .swiper-container {
        width: 100%;
        height: 100%;
        overflow: initial;
        position: relative;
        &::after {
          content: "";
          display: inline-block;
          width: 100vw;
          height: 560px;
          background: rgba(244, 244, 244, 0.85);
          position: absolute;
          top: -150px;
          left: -100.9vw;
          border-radius: 10px;
          z-index: 2;
        }
        &::before {
          content: "";
          display: inline-block;
          width: 100vw;
          height: 560px;
          background: rgba(244, 244, 244, 0.85);
          position: absolute;
          top: -150px;
          right: -100.9vw;
          border-radius: 10px;
          z-index: 2;
        }
        .swiper-slide {
          font-size: 18px;
          display: flex;
          justify-content: center;
          align-items: center;
          transition: 300ms;
          margin-right: 0;
          width: 327px;
          height: 340px;
          padding-right: 24px;
        }
        // 更改swiper初始样式 end
        .banner_box {
          width: 100%;
          height: 100%;
          background-color: #fff;
          box-shadow: 0px 0px 20px rgba(0, 0, 0, 0.1);
          border-radius: 10px;
          padding: 16px;
          box-sizing: border-box;
          cursor: pointer;
          &:hover {
            -moz-transform: translateY(-10px);
            -webkit-transform: translateY(-10px);
            -o-transform: translateY(-10px);
            -ms-transform: translateY(-10px);
            transform: translateY(-10px);
            box-shadow: 0px 0px 20px rgba(0, 0, 0, 0.16);
            .bible_title {
              color: #22b79e !important;
            }
          }
          .banner_link {
            width: 100%;
            height: 100%;
            display: inline-block;

            .bible_img_box {
              width: 100%;
              position: relative;
              .bible_img {
                width: 100%;
                height: 203px;
                border-radius: 10px;
                object-fit: cover;
                background-color: #606266;
              }

              .bible_time {
                position: absolute;
                bottom: 0;
                left: 0;
                width: auto;
                height: 28px;
                background: rgba(34, 183, 158, 0.8);
                border-radius: 0px 10px 0px 10px;
                font-size: 12px;
                line-height: 21px;
                color: #fff;
                text-align: center;
                line-height: 28px;
                padding: 0 8px;
              }
              .bottom_shadow {
                width: 279px;
                height: 14px;
                position: absolute;
                bottom: -14px;
                left: 8px;
              }
            }

            .bible_title {
              margin: 24px 0 11px;
              font-size: 16px;
              line-height: 21px;
              height: 42px;
              color: #333333;
            }
            .bible_info {
              font-size: 12px;
              line-height: 21px;
              color: #999;
              display: flex;
              justify-content: space-between;
              .left {
                max-width: 50%;
                overflow: hidden;
                img {
                  width: 24px;
                  height: 24px;
                  border-radius: 50%;
                  margin-right: 8px;
                }
              }
              .right {
                max-width: 50%;
                overflow: hidden;
                img {
                  width: 12px;
                  height: 12px;
                  margin-right: 4px;
                }
              }
            }
          }
        }
      }
      --swiper-theme-color: #b2b2b2;
      --swiper-navigation-size: 23px;
      .swiper-button-next {
        right: -18px;
      }
      .swiper-button-prev {
        left: -18px;
      }
      .swiper-button-disabled {
        display: none;
      }
      .arrows {
        width: 44px;
        height: 44px;
        font-weight: 700;
        transform: translate(-0%, -33%);
        transition: all 0.35s;
        background: rgba(255, 255, 255, 0.8);
        border-radius: 50%;
        border: 1px solid #d8dce6;
        box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.16);
        &::after {
          font-size: 15px;
        }
      }
    }
  }
}
@media screen and (max-width: 1500px) and (min-width: 270px) {
  .container {
    .bible_box {
      .me-list {
        .swiper-container {
          &::before {
            background: #f4f4f4;
          }
          &::after {
            background: #f4f4f4;
          }
          .swiper-slide {
            width: 260px;
            height: 287px;
            padding-right: 20px;
          }
          .banner_box {
            box-shadow: none;
            .banner_link {
              .bible_img_box {
                .bible_img {
                  height: 157px;
                }
                .bottom_shadow {
                  width: 216px;
                  height: 10px;
                  bottom: -10px;
                  left: 6px;
                }
              }
            }
          }
        }
      }
    }
  }
}
</style>
